import React, { useRef, useState, useEffect } from "react";
import "../styles/Services.css"; // Reusing the service styles for consistency

const Testimonials = () => {
  const testimonialsRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const testimonials = [
    {
      name: "Rajesh Sharma",
      company: "Sharma Trading Co.",
      message: "AROCL Customs Solutions provided exceptional service for our international shipments. Their expertise in customs clearance saved us time and money.",
      rating: 5
    },
    {
      name: "Priya Desai",
      company: "Desai Logistics India",
      message: "Reliable and professional. We trust AROCL for all our warehousing and distribution needs. Highly recommended!",
      rating: 5
    },
    {
      name: "Arjun Patel",
      company: "Patel Imports Ltd",
      message: "The team's knowledge of air and sea cargo regulations is outstanding. They handled our complex shipment with ease.",
      rating: 4
    },
    {
      name: "Neha Gupta",
      company: "Tech Innovations India",
      message: "Outstanding logistics support. They managed our supply chain efficiently during peak season. Will definitely use again.",
      rating: 5
    },
    {
      name: "Vikram Singh",
      company: "Singh Enterprises",
      message: "Great communication and timely delivery. The insurance coverage gave us peace of mind for our valuable cargo.",
      rating: 4
    },
    {
      name: "Anjali Reddy",
      company: "Reddy Export Solutions",
      message: "Professional team with deep industry knowledge. Helped us navigate complex customs procedures smoothly.",
      rating: 5
    },
    {
      name: "Rohan Malhotra",
      company: "Malhotra Manufacturing",
      message: "Excellent warehousing facilities and inventory management. Their tracking system is top-notch.",
      rating: 4
    },
    {
      name: "Divya Nair",
      company: "Nair Retail Group",
      message: "Fast and reliable air cargo services. Our products reached customers on time every single delivery.",
      rating: 5
    }
  ];

  const renderStars = (rating) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  const checkScrollButtons = () => {
    if (testimonialsRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = testimonialsRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  const scrollLeft = () => {
    testimonialsRef.current?.scrollBy({ left: -320, behavior: "smooth" });
  };

  const scrollRight = () => {
    testimonialsRef.current?.scrollBy({ left: 320, behavior: "smooth" });
  };

  useEffect(() => {
    checkScrollButtons();
    const handleScroll = () => checkScrollButtons();
    const element = testimonialsRef.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
      return () => element.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <div className="service-container testimonials-section">
      <h1 className="service-title">Testimonials</h1>
      <p className="service-description">
        Hear what our clients have to say about our services and commitment to excellence.
      </p>
      <div className="testimonial-scroller-wrapper">
        <button
          type="button"
          className="testimonial-arrow testimonial-arrow-left"
          onClick={scrollLeft}
          disabled={!canScrollLeft}
          aria-label="Scroll testimonials left"
        >
          ‹
        </button>
        <div className="testimonials-scroll" ref={testimonialsRef}>
          {testimonials.map((testimonial, index) => {
            const variantClass = index % 3 === 0 ? "variant-a" : index % 3 === 1 ? "variant-b" : "variant-c";
            return (
              <div key={index} className={`testimonial-card ${variantClass}`}>
                <div className="testimonial-quote">“</div>
                <div className="testimonial-rating">
                  {renderStars(testimonial.rating)}
                </div>
                <p className="testimonial-message">{testimonial.message}</p>
                <div className="testimonial-author">
                  <strong>{testimonial.name}</strong>
                  <span>{testimonial.company}</span>
                </div>
              </div>
            );
          })}
        </div>
        <button
          type="button"
          className="testimonial-arrow testimonial-arrow-right"
          onClick={scrollRight}
          disabled={!canScrollRight}
          aria-label="Scroll testimonials right"
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default Testimonials;